import React from "react"
import Heading from "@/common/components/_UI/Heading"
import styled from "styled-components"

interface TheySaysProps {
  content1: string
  content2: string
  themeNew?: boolean
}

export default function TheySays({
  content1,
  content2,
  themeNew
}: TheySaysProps) {
  return (
    <Wrapper>
      <Heading as="h3" content={content1} primary themeNew={themeNew} />
      <Heading as="h3" content={content2} />
    </Wrapper>
  )
}
const Wrapper = styled.div`
  width: 100%;
`
